document.addEventListener("DOMContentLoaded", function() {
  // Grab the social section
  const socialSection = document.querySelector('#shopify-section-sections--25758672617853__social_follow_section_qyTmtg');
  
  // Grab the nav bar container
  const navBar = document.querySelector('.header__inline-menu'); // adjust selector to your theme

  if (socialSection && navBar) {
    // Move the social section above the nav bar
    navBar.parentNode.insertBefore(socialSection, navBar);
  }
});
document.addEventListener("DOMContentLoaded", function() {
  const cards = document.querySelectorAll('.pet-product-card');

  cards.forEach(card => {
    const button = card.querySelector('.pet-upload-btn');
    
    // Select outer .card__information inside .card__inner > .card__content
    const outerInfo = card.querySelector('.card__content.outer > .card__information');

    if (button && outerInfo) {
      outerInfo.parentNode.insertBefore(button, outerInfo);
    }
  });
});

